import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LearningTrailsService } from '@app/core';

export const TrailResolver: ResolveFn<any> = (route, state) => {
  const courseService = inject(LearningTrailsService);

  return courseService.show(route.params.trail_slug);
};
